export default {
    name: 'contactList',
    phones: null,
    container: null,
    limit: 5,
    actionButton: null,
    contacts: null,
    init() {
        this.container = document.querySelector("#js_contact-list");

        if (!this.container) {
            return;
        }
        this.handleContactList();

        this.phones = this.container.querySelectorAll("a[href^='tel']");
        this.emails = this.container.querySelectorAll("a[href^='mailto']");

        for (const link of this.phones) {
            const text = link.innerText;
            link.innerText = "Vis telefon";
            link.addEventListener("click", (e) => {
                if (link.innerText === "Vis telefon") e.preventDefault();
                     link.innerText = text;
            });
        }

        for (const link of this.emails) {
            const text = link.innerText;
            link.innerText = "Vis e-post";
            link.addEventListener("click", (e) => {
                if (link.innerText === "Vis e-post") e.preventDefault();
                    link.innerText = text;
            });
        }
    },
    handleContactList(){


        if(this.setContactListLength() <= 5){
            return;
        }

        this.actionButton = document.createElement("a");
        this.actionButton.innerText = "Vis mer";
        this.actionButton.classList.add("default-link");
        this.actionButton.style.marginTop="1rem";
        this.actionButton.style.display="block";
        this.actionButton.style.textAlign="center";
        this.container.after(this.actionButton);

        this.actionButton.addEventListener("click", e => {
            this.limit+=5;
            this.setContactListLength();
        });
    },

    setContactListLength(){
        const items = this.container.querySelectorAll(".contact-item");

        if((this.limit >= items.length-1) && this.actionButton){
            this.actionButton.remove();
         }

        items.forEach((item, index) => {
            if(index > this.limit){
                item.style.display="none";
            } else {
                item.style.display="";
            }
        });

       return items.length-1;
    },
};
